export const helpDe = {
  open: 'Hilfe öffnen',
  title: 'Hilfe',
  search: 'Hilfe durchsuchen',
  noResults: 'Keine passenden Hilfeartikel.',
  loading: 'Hilfe wird geladen …',
  error: 'Die Hilfe konnte nicht geladen werden.',
  retry: 'Erneut versuchen',
  fallback: 'Dieser Artikel ist noch nicht in Ihrer Sprache verfügbar.',
  allTopics: 'Alle Themen',
  related: 'Verwandte Themen',
  empty:
    'Für Ihre Rolle sind derzeit keine Hilfeartikel verfügbar. Sie können die Inhalte erneut laden.',
  translationStatus:
    '{{current}}/{{total}} Artikel aktuell · {{locales}} Sprachen · {{fallback}} Fallbacks · {{stale}} veraltet',
  categories: {
    general: 'Allgemein',
    accounting: 'Buchhaltung',
    documents: 'Belege',
    finance: 'Finanzen',
    'getting-started': 'Erste Schritte',
    manufacturing: 'Produktion',
    marketing: 'Marketing',
    partners: 'Geschäftspartner',
    plm: 'Produktentwicklung',
    portal: 'Kundenportal',
    products: 'Artikel',
    questionnaires: 'Fragebögen',
    sales: 'Vertrieb',
    security: 'Sicherheit',
    settings: 'Einstellungen',
  },
} as const;
